import { Component, OnInit, Input, ViewChild, ElementRef, NgZone, AfterViewInit, SimpleChanges, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { HttpService } from 'app/shared/services/http.service';
import * as emiGlobals from 'app/globals';
import { InputType, QuestionCategory } from 'app/globals';
import { DomSanitizer } from '@angular/platform-browser';
import { CalculatorService } from 'app/calculators/calculator.service';
import { LoanOfferGenService } from 'app/loan/services/loan-offer-gen.service';
import { DatePipe } from '@angular/common';
import { ProductOffer } from 'app/calculators/Product';
import { ActivatedRoute } from '@angular/router';
import { Http } from '@angular/http';

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.css']
})

export class QuestionsComponent implements OnInit {

  @Input('configData') data;
  @ViewChild('videoPlayer') videoplayer: any;
  @ViewChild('companySelect') public companySelect: ElementRef; // jquery plugin
  
  //prePopulatedata:any[]=[{"id":"856","name":"House"},{"id":"1035","name":"Desperate Housewives"}];
  prePopulatedata:any[]=[];
  //{"id":"5257969","name":"WIPRO CHANDRIKA PRIVATE LIMITED - Axis Bank"}
  //prePopulatedata:{ id: number; name: string }[] = [];
  //prePopulatedata=[];
  empName=[];


  productOffer: ProductOffer = new ProductOffer();

  questionForm: FormGroup;
  form: FormGroup;

  showTextField: boolean;
  showcompany: boolean;
  showButton: boolean;
  showHeading: boolean;
  enableSubmit: boolean;
  showBankList: boolean;
  showDefaultValues: boolean;
  showCompnyGroup: boolean;

  productList : any[];
  status : any;
  statusData : any;
  resultList: any;
  maxStarList: any[];
  noOfStars = 5;
  ratedCount: any;
  imageUrl: any;
  description: any;
  videoUrl: any;
  displayUrl: any;
  objectProps: any;
  dataObject: any;
  comapny_selector;
  type: any;
  i: any = 0;
  activeButton: any;
  options_bank: any;


  limit = 1;
  active_group_id = 0;
  question_answer: { [id: string]: any } = {};
  question_catgeory: { [id: string]: any } = {};

  formList = [];
  companyId = [];
  newSubList = [];
  checkList = [];
  subQuestionList = [];
  dataList = [];
  questionList = [];
  dropDownList = [];
  companyList = [];
  companyFirstWord: any;

  
  @ViewChild('search') public searchElementRef: ElementRef;
  empNamestring: any;
  constructor(public httpService: HttpService, private fb: FormBuilder,
    private sanitizer: DomSanitizer, public calculatorService: CalculatorService,
    private datePipe: DatePipe, public route: ActivatedRoute, private el: ElementRef, private http: Http) {
  }

  // async getLeadById(leadId): Promise<any> {
  //   //const apiUrl = 'https://api.example.com/companies'; // Replace with your API URL
  //   //const jwttoken = this.getjwtToken();
  //   //console.log("JWT Token is",jwttoken)
  //   //const jwttokenobject = JSON.parse(await jwttoken); // Parse the JSON string to an object
  //   //const parsedBody = jwttokenobject._body; // Parse the JSON string to an object
  //   //let token = parsedBody.token;
    
  //   //console.log("JWT Token is",token)

  //   const apiUrl1 = emiGlobals.jwtTokenUrl ; // Replace with your API URL
   
  //   const promise  = this.http.get(apiUrl1).toPromise();
  //   promise.then((data: any)=>{
  //    // console.log("Promise resolved with: " + JSON.stringify(data));

  //     const body = JSON.parse(data._body); // Parse the JSON string to an object
  //     let token = body.token;
  //     console.log("Token: " + JSON.stringify(token));
  //     //return token
  //     const apiUrl = emiGlobals.getLeadByIdUrl + '/' + leadId+'?token='+token; // Replace with your API URL
  //     const promise1 =  this.http.get(apiUrl).toPromise();
  //     promise1.then((data: any)=>{
  //       // console.log("Promise resolved with: " + JSON.stringify(data));
   
  //        const body = JSON.parse(data._body); // Parse the JSON string to an object
  //        console.log("The Body is: " + JSON.stringify(body));
  //        const lead = body.leads[0]
        
  //        console.log("The Body is: " + JSON.stringify(lead));
  //        return lead;
   
  //      }).catch((error)=>{
  //        console.log("Promise rejected with " + JSON.stringify(error));
  //      });

  //   }).catch((error)=>{
  //     console.log("Promise rejected with " + JSON.stringify(error));
  //   });



  //  // const apiUrl = emiGlobals.getLeadByIdUrl + '/' + leadId+'?token='+jwttoken; // Replace with your API URL
  //  // return this.http.get(apiUrl).toPromise();
  //   //return this.httpService.getById(emiGlobals.getLeadByIdUrl + '/' + leadId).toPromise();
  // }

  // async getjwtToken(): Promise<any> {
  //   const apiUrl1 = emiGlobals.jwtTokenUrl ; // Replace with your API URL
   
  //   const promise  = this.http.get(apiUrl1).toPromise();
  //   promise.then((data: any)=>{
  //    // console.log("Promise resolved with: " + JSON.stringify(data));

  //     const body = JSON.parse(data._body); // Parse the JSON string to an object
  //     let token = body.token;
  //     console.log("Token: " + JSON.stringify(token));
  //     return token
  //   }).catch((error)=>{
  //     console.log("Promise rejected with " + JSON.stringify(error));
  //   });
      

    

  
    
 
  //   //return this.httpService.getById(emiGlobals.getLeadByIdUrl + '/' + leadId).toPromise();
  // }


  async  ngOnInit(): Promise<void> {
    this.route.data.subscribe(({ lead }) => {
      // do something with your resolved data ...
      //console.log("Theeee Lead ......:"+ JSON.stringify(lead))
      if(lead != null)
      {
      const empNameString = lead.companyId;
      const companyArray  = JSON.parse(empNameString);
         
        // Iterate over each object and push it into the result array
        companyArray.forEach((company: any) => {
        let newObject = { "id": company.id.toString(), "name": company.name };
        // {"id":"856","name":"House"},
        //alert(JSON.stringify(newObject))
        
          this.prePopulatedata.push(company);
        });
        debugger 
        const other_info = JSON.parse(lead.other_info);
        this.productOffer.amount = other_info.loanamount;
        this.productOffer.salary = other_info.salary;
        this.productOffer.tenure = other_info.tenure;
        this.productOffer.salaryAccountBank = parseInt(other_info.salary_bank_id);
        this.productOffer.gender =parseInt(other_info.gender);
        this.productOffer.residencyId = parseInt(other_info.residencyId);
        this.productOffer.companyName = other_info.company;
        this.productOffer.age = other_info.age;
        this.productOffer.city = other_info.city;
        this.productOffer.emi = other_info.emi;

        // this.questionList.forEach(question => {
          
        //   if (question.category_id === QuestionCategory.loanAmount) {
        //     question.default_value = this.productOffer.amount;
        //   } else if (question.category_id === QuestionCategory.salary) {
        //     question.default_value = this.productOffer.salary;
        //   } else if (question.category_id === QuestionCategory.tenure ) {
        //     question.default_value = this.productOffer.tenure;
        //   } else if (question.category_id === QuestionCategory.salaryAccountBank ) {
        //   //  this.productOffer.salaryAccountBank = this.productOffer.salaryAccountBank.toString().replace("+"," ")  
            
        //     question.default_value = this.productOffer.salaryAccountBank;
        //     localStorage.setItem('salaryBank', this.productOffer.salaryAccountBank);
        //   } else if (question.category_id === QuestionCategory.gender ) {
        //     question.default_value = this.productOffer.gender;
        //   } else if (question.category_id === QuestionCategory.residencyId ) {
        //     question.default_value = this.productOffer.residencyId;
        //   } 
        //   });
       }
    })

    const lead = this.route.snapshot.data['lead'];
    //alert(lead)
    //debugger
    //console.log("Activated Route is:  "+this.route); // ActivatedRoute
    this.route.queryParams.subscribe(result => {
      // To Hide the employer name field in company specific page 
      if (result['companygrp']) {
        debugger
        this.productOffer.listType = 1;
        this.showCompnyGroup = false;
        this.route.params.subscribe(parms => {
          console.log('--params-----' , parms, this.productOffer);
          // this.dataList.push({
          //   'id': '',
          //   'value': parms['id'],
          //   'category_id': 10
          // });
          // this.companyId.push(parms['id']);
         this.productOffer.groupId = parms['calculator-slug'];
          console.log('--para this.productOffer.groupIdms-----' ,  this.productOffer.groupId);
        });
      } else {
        this.showCompnyGroup = true;
      }
      console.log('--ppppp-----' ,  this.productOffer);
    });
    this.ratedCount = 0;
    this.showTextField = true;
    this.productOffer.questionType = 1;
    this.httpService.getAll(emiGlobals.bankListsUrl).subscribe(result => {
      this.options_bank = result.banks;
    })
    this.questionList = this.data.configData;
    debugger;
    this.productList = this.data.productList;
    this.status = this.data.statusId;
    this.statusData = this.data.statusData;
    this.dataObject = this.questionList;
    this.getFormData(); // to get dynamic form fields

    // this.productOffer.questionType = this.data.questionType;
    this.questionForm = this.fb.group({
      'text': ['', Validators.compose([Validators.required])],
      'employername': [null],
      'loanAmount': [''],
      'salaryAccountBank': ['']
    });

       this.questionList.forEach(question => {
         
      if (question.category_id === QuestionCategory.salaryAccountBank ) {
        debugger
          localStorage.setItem('salaryBank',  question.default_value);
        } 
        }); 

    this.dropDownList = [];
    this.maxStarList = [];
    for (let star = 0; star < this.noOfStars; star++) {
      this.maxStarList.push(star + 1);
    }
    this.route.queryParams.subscribe(params => {

      // if (params['loanAmount']) {
        //   this.productOffer.amount = params['loanAmount'];
        //   this.productOffer.salary = params['salary'];
        //   this.productOffer.tenure = params['tenure'];
        //   this.productOffer.salaryAccountBank = params['salary_bank_id'];
        //   this.productOffer.gender = params['gender'];
        //   this.productOffer.residencyId = params['residencyId'];
        //   this.productOffer.companyName = params['company'];
        
        //   this.productOffer.companyName= this.productOffer.companyName.replace("+"," ");
        //   this.companyFirstWord = this.productOffer.companyName.replace(/ .*/,'');
        //   //alert(this.productOffer.amount )

        //   this.empNamestring = params['empName'];
        //   this.empName = this.convertStringToArray(this.empNamestring);
        //   console.log(this.empName)
        //   debugger
      //   this.empName.forEach(emname => {
          //     //let newObject = { id: emname.id, name: emname.name.toString() };
          //     this.prePopulatedata.push(emname);
        //   });
       
        //   this.replacePlusWithSpace();
        
        //   // Default values for lead page
//   this.questionList.forEach(question => {
      //     if (question.category_id === QuestionCategory.loanAmount) {
      //       question.default_value = this.productOffer.amount;
      //     } else if (question.category_id === QuestionCategory.salary) {
      //       question.default_value = this.productOffer.salary;
      //     } else if (question.category_id === QuestionCategory.tenure ) {
      //       question.default_value = this.productOffer.tenure;
      //     } else if (question.category_id === QuestionCategory.salaryAccountBank ) {
      //     //  this.productOffer.salaryAccountBank = this.productOffer.salaryAccountBank.toString().replace("+"," ")  
            
      //       question.default_value = this.productOffer.salaryAccountBank;
      //       localStorage.setItem('salaryBank', this.productOffer.salaryAccountBank);
      //     } else if (question.category_id === QuestionCategory.gender ) {
      //       question.default_value = this.productOffer.gender;
      //     } else if (question.category_id === QuestionCategory.residencyId ) {
      //       question.default_value = this.productOffer.residencyId;
      //     } 
      //     });

          
      // }

      if (params['leadId']) {

        //const leadData = this. getLeadById(params['leadId']);
        //console.log("Leaddata is", leadData)
        //alert(JSON.stringify(leadData))
        //this.httpService.getById(emiGlobals.getLeadByIdUrl + '/' + params['leadId']).subscribe(result => {
        // const other_infoString = result.leads[0].other_info
        // const other_infoObject = JSON.parse(other_infoString);
         
        // this.productOffer.amount = other_infoObject.loanamount;
        // this.productOffer.salary = other_infoObject.salary;
        // this.productOffer.tenure = other_infoObject.tenure;
        // this.productOffer.salaryAccountBank = other_infoObject.salary_bank_id;
        // this.productOffer.gender = other_infoObject.gender;
        // this.productOffer.residencyId = other_infoObject.residencyId;
        // //this.productOffer.companyName = params['company'];
        // debugger
        // const empNameString = result.leads[0].companyId;


        
        
        
        // const companyArray  = JSON.parse(empNameString);
         
        // // Iterate over each object and push it into the result array
        // companyArray.forEach((company: any) => {
        // let newObject = { "id": company.id.toString(), "name": company.name };
        // // {"id":"856","name":"House"},
        // //alert(JSON.stringify(newObject))
        
        //   this.prePopulatedata.push(company);
        // });
       
       // alert(JSON.stringify(this.prePopulatedata))
        debugger
        this.questionList.forEach(question => {

          if (question.category_id === QuestionCategory.loanAmount) {
            question.default_value = this.productOffer.amount;
          } else if (question.category_id === QuestionCategory.salary) {
            question.default_value = this.productOffer.salary;
          } else if (question.category_id === QuestionCategory.tenure ) {
            question.default_value = this.productOffer.tenure;
          } else if (question.category_id === QuestionCategory.salaryAccountBank ) {
          //  this.productOffer.salaryAccountBank = this.productOffer.salaryAccountBank.toString().replace("+"," ")  
          
            question.default_value = this.productOffer.salaryAccountBank;
            localStorage.setItem('salaryBank', this.productOffer.salaryAccountBank);
          } else if (question.category_id === QuestionCategory.gender ) {
            question.default_value = this.productOffer.gender;
          } else if (question.category_id === QuestionCategory.residencyId ) {
            question.default_value = this.productOffer.residencyId;
          } else if (question.category_id === QuestionCategory.age ) {
            question.default_value = this.productOffer.age;
          } else if (question.category_id === QuestionCategory.city ) {
            question.default_value = this.productOffer.city;
          } else if (question.category_id === QuestionCategory.emi ) {
            question.default_value = this.productOffer.emi;
          } 
          });
         
        //});

        // this.productOffer.amount = params['loanAmount'];
        // this.productOffer.salary = params['salary'];
        // this.productOffer.tenure = params['tenure'];
        // this.productOffer.salaryAccountBank = params['salary_bank_id'];
        // this.productOffer.gender = params['gender'];
        // this.productOffer.residencyId = params['residencyId'];
        // this.productOffer.companyName = params['company'];

        //this.productOffer.companyName= this.productOffer.companyName.replace("+"," ");
        //this.companyFirstWord = this.productOffer.companyName.replace(/ .*/,'');
        //alert(this.productOffer.amount )


        

        // this.empNamestring = params['empName'];
        // this.empName = this.convertStringToArray(this.empNamestring);
        // console.log(this.empName)
        
        // this.empName.forEach(emname => {
        //   //let newObject = { id: emname.id, name: emname.name.toString() };
        //   this.prePopulatedata.push(emname);
        // });
       
        // this.replacePlusWithSpace();
        
        // Default values for lead page
       

          
      }


    });
// mmp start
    this.productOffer.questionType = 2;
    this.showTextField = true;
    // mmp end
  }
  
  replacePlusWithSpace() {
    this.prePopulatedata = this.prePopulatedata.map(item => {
      return {
        ...item,
        name: item.name.replace(/\+/g, ' ')
      };
    });
  }
  
   // To get company list 
  ngAfterViewInit() {
    this.form.patchValue({
      2: this.productOffer.amount,
      4: this.productOffer.salary
     // email: "yuvayuvaraj@google.com",
    })
    //this.companySelect.nativeElement.value = this.companyFirstWord;
   this.getCompanyList();
   if(this.productOffer.amount  != undefined)
   {
   let element = document.getElementById('leac') as HTMLElement;

   //alert("Yes")
   element.click();
 }
  
  }



  
  
   convertStringToArray(input: string): number[] {
    try {
      return JSON.parse(input);
    } catch (error) {
      console.error('Error parsing string to array', error);
      return [];
    }
  }

  // get company list 
  getCompanyList() {
    const token = localStorage.getItem('id_token');
    this.productOffer.salaryAccountBank = localStorage.getItem('salaryBank');
      this.productOffer.listType = this.data.listId;
      this.comapny_selector = (<any>$(this.companySelect.nativeElement)).tokenInput(emiGlobals.companyBankListUrl + '/' + this.data.listId
        + '/' + this.data.productId + '?token=' + token + '&salarybank=' + this.productOffer.salaryAccountBank, {
          theme: 'facebook',
          minChars: 3,
          preventDuplicates: true,
          prePopulate: this.prePopulatedata ,
          hintText: 'Search your company name',
          crossDomain: false,
          onResult: function (company: any) {
            var PlCompanyListFiltered = [];
            if (this.PlCompanyListFiltered) {
              PlCompanyListFiltered.length = 0;
            }
            PlCompanyListFiltered = company;
            company = PlCompanyListFiltered;
            if ($.isEmptyObject(company)) {
              var text = $('tester').text();
              return [{ id: '0', name: text.replace('Company Name', '') }];
            } else {
              $('.gifImage').hide();
              return company;
            }
          },
          get: function () {
            return this.data('tokenInputObject').getTokens();
          },
        });
  }


  // dynamic form validation
  private mapValidators(validators) {
    const formValidators = [];
    if (validators) {
      for (const validation of Object.keys(validators)) {
        if (validation === 'required') {
          formValidators.push(Validators.required);
        } else if (validation === 'min') {
          //  formValidators.push(Validators.min(validators[validation]));
        }
      }
    }
    return formValidators;
  }

  // on change of options
  onChangeOfOption(data, event) {
    if (data.category_id === QuestionCategory.city) {
      //this.productOffer.locationId = data.id;
this.productOffer.locationId = event;
    }
    if (data.category_id === QuestionCategory.gender) {
      //this.productOffer.gender = data.id;
this.productOffer.gender = event;
    }
    if (data.category_id === QuestionCategory.residencyId) {
      this.productOffer.residencyId = event;
    }

  }

  // on change of checkbox
  onCheckboxChange(row, event) {
    this.showHeading = true;
    if (event.target.checked === true) {
      // to display checked headings
      this.httpService.getById(emiGlobals.subQuestionDropdownUrl + '/' + row.id).subscribe(result => {
        this.newSubList.push({
          'dropdown': result[0].questions,
          'id': result[0].id,
          'option_id': result[0].option_id
        });
        if (this.newSubList.length > 1) {
          this.showHeading = true;
        }
      });
    }
  }

  // on click of radio button
  onItemChange(data) {
    this.activeButton = data.id;
    this.next(this.active_group_id);

    if (data.category_id === QuestionCategory.city) {
      this.productOffer.locationId = data.id;
    }
    if (data.category_id === QuestionCategory.gender) {
      this.productOffer.gender = data.id;
    }

    if (data.category_id === QuestionCategory.residencyId) {
      this.productOffer.residencyId = data.id;
    }
  }

  // on click of back button
  back(id) {
    this.type = '';
    if (id !== null) {
      this.active_group_id = id - 1;
    }
    this.next(id - 2);
  }


  getGroupId(i) {
    return Math.floor(i / this.limit);
  }

  // on change of input field
  onchangeOfanswer(q, answer, qn) {
    this.question_answer[qn.id] = answer;
    this.question_catgeory[qn.id] = qn.category_id;
  }

  // on click of check offer button
  onClickOfCheckOffer() {
    this.companyId = [];
    this.formList = [];
    this.companyList = [];
    
    
    this.formList.push(this.form.value);
    for (const key of this.formList) {
      debugger;
      // tslint:disable-next-line:forin
      for (const id in key) {
        debugger;
        this.productOffer.residencyId = id;
        if (id !== '10' && Number(id) !== QuestionCategory.residencyId) {
          this.question_answer[id] = key[id];
          this.question_catgeory[id] = Number(id);
        } if (Number(id) === QuestionCategory.residencyId) {
          this.productOffer.residencyId = key[id];
        } if (Number(id) === QuestionCategory.salaryAccountBank) {
          this.productOffer.salaryAccountBank = key[id];
        } else {
        }
      }
    }
    this.dataList.length = 0;
    // tslint:disable-next-line:forin
    for (const key in this.question_answer) {
      this.dataList.push({
        'id': Number(key),
        'value': this.question_answer[key],
        'category_id': this.question_catgeory[key]
      });
    }
    const tokenInput = this.comapny_selector.tokenInput('get');
    tokenInput.forEach(input => {
      debugger;
      this.companyId.push(input.id);
      
       var object = {
        id :  input.id, 
        name : input.name
      }
      this.companyList.push(object);
    });

  
    this.dataList.push({
      'id': '',
      'value': this.companyId,
      'category_id': 10
    });
    debugger;
    this.productOffer.product = this.data.productId;
    this.productOffer.questionAnswer = this.dataList;
    this.productOffer.bankId = this.data.bankId;
    this.productOffer.companyName = this.companyList;
    const myDate = new Date();

    if(this.productOffer.groupId) {
      debugger;
      this.companyId.push(this.productOffer.groupId);
      this.dataList.push({
        'id': '',
        'value': this.companyId,
        'category_id': 10
      });
    }

    this.productOffer.currentDate = this.datePipe.transform(myDate, 'yyyy-MM-dd');
    this.productOffer.status = this.data.statusId;
    console.log('---rrrrrrrr------', this.productOffer);
    if(!this.showCompnyGroup) {
      this.productOffer.listType = 1;
    }
    if (this.productOffer.listType === 1) {
      debugger;
      if (this.productOffer !== undefined) {
        this.httpService.create(emiGlobals.companySpecificOfferUrl, this.productOffer).subscribe(result => {
          const value = JSON.parse(result._body);
          this.calculatorService.offer = value.offers;
          this.calculatorService.getCurrentData(value);
          this.calculatorService.getInputData(this.productOffer);
        });
      }
    } 
    else { // for home loan
      debugger;
      if (this.productOffer !== undefined) {
        this.httpService.create(emiGlobals.productOfferUrl, this.productOffer).subscribe(result => {
          const value = JSON.parse(result._body);
          this.productOffer.offer = value;
          this.calculatorService.getCurrentData(value);
          this.calculatorService.getInputData(this.productOffer);
        });
      }
    }


    // if (tokenInput.length !== 0) {
    //   if (this.productOffer !== undefined) {
    //     this.httpService.create(emiGlobals.companySpecificOfferUrl, this.productOffer).subscribe(result => {
    //       const value = JSON.parse(result._body);
    //       this.offer = value;
    //       this.calculatorService.getCurrentData(this.offer);
    //       this.calculatorService.getInputData(this.productOffer);
    //       this.router.navigateByUrl(this.url);
    //      // this.router.navigate(['savings']);
    //     });
    //   }
    // } else {
    //   if (this.productOffer !== undefined) {
    //     this.httpService.create(emiGlobals.productOfferUrl + '/' + this.productOffer.product, this.productOffer).subscribe(result => {
    //       const value = JSON.parse(result._body);
    //       this.offer = value;
    //       this.calculatorService.getCurrentData(this.offer);
    //       this.calculatorService.getInputData(this.productOffer);
    //      // this.router.navigate(['savings']);
    //     });
    //   }
    // }
    this.httpService.create(emiGlobals.loanEligibiltyUrl, this.productOffer).subscribe(
      result => {
        this.calculatorService.getLoanEligibilty(JSON.parse(result._body));
      }
    );
  }

  // on click of next button 
  next(id) {
    this.showDefaultValues = false;
    this.showHeading = false;
    this.questionList.forEach(element => {
      const index = this.questionList.indexOf(element);
      if (index === id + 1) {
        if (element.option_id === InputType.button) {
          console.log('------------11111111111111111111----------------', index);
          this.httpService.getById(emiGlobals.optionUrl + '/' + element.id).subscribe(result => {
            if (result.length > 0) {
              this.dropDownList = result;
              this.dropDownList.forEach(option => {
                if (element.id === option.question_id) {
                  this.showTextField = false;
                  this.showcompany = false;
                  this.showBankList = false;
                }
              });
            }
          });
        } else if (element.option_id === InputType.text) {
          console.log('------------2222222222222222222----------------', element);
          if (element.category_id === QuestionCategory.company) {
            this.showTextField = false;
            this.showcompany = true;
            this.showBankList = false;
            jQuery('body').on('focus', '#token-input-employername', function (event) {
            });
          } else if (element.category_id === QuestionCategory.salaryAccountBank) {
            this.showTextField = false;
            this.showcompany = false;
            this.showBankList = true;
            this.httpService.getAll(emiGlobals.bankListsUrl).subscribe(result => {
              this.options_bank = result.banks;
            })
            // this.options_bank = this.loanOfferService.getBankList();
          } else {
            this.showcompany = false;
            this.showBankList = false;
          }
          this.showTextField = true;
        } else if (element.option_id === InputType.date) {
          this.showcompany = false;
          this.showBankList = false;
          this.showTextField = true;
          this.type = 'date';
        } else if (element.option_id === InputType.image) {
          this.showcompany = false;
          this.showBankList = false;
          this.type = 'file';
          this.showTextField = true;
        } else if (element.option_id === InputType.ratings) {
          this.showTextField = false;
          this.showcompany = false;
          this.showBankList = false;
        } else if (element.option_id === InputType.cards) {
          this.showTextField = false;
          this.showcompany = false;
          this.showBankList = false;
          this.httpService.getById(emiGlobals.optionUrl + '/' + element.id).subscribe(result => {
            this.resultList = result;
            this.resultList.forEach(data => {
              if (data.image_url) {
                this.imageUrl = data.image_url.split(',');
                this.description = data.description.split(',');
              }
            });
          });
        } else if (element.option_id === InputType.checkbox) {
          this.showTextField = false;
          this.showcompany = false;
          this.showBankList = false;
        } else if (element.option_id === InputType.video) {
          this.httpService.getById(emiGlobals.optionUrl + '/' + element.id).subscribe(result => {
            this.videoUrl = result[0].video_url;
            const videoId = this.videoUrl.split('?v=');
            const YouTubeVideoId = videoId[1];
            var quote_str = 'https://www.youtube.com/embed/' + YouTubeVideoId + "";
            const url = 'https://www.youtube.com/embed/tgbNymZ7vqY';
            this.displayUrl = this.sanitizer.bypassSecurityTrustResourceUrl(quote_str);
          });
          this.showTextField = false;
        } else {
          this.showTextField = false;
          this.showcompany = false;
          this.showBankList = false;
        }
      }
    }); // end of questionList
    if (id != null) {
      this.active_group_id = id + 1;
    }
    if (id === this.questionList.length - 2) {
      debugger
      this.enableSubmit = true;
    }
  }   //  end of next

  // on change of star rating

  toggleRating(s: number) {
    this.ratedCount = s;
  }


  // defaultOffer() {
  //   this.httpService.getAll(emiGlobals.productOfferUrl + '/' + this.data.productId + '/' + 500000 + '/' +
  //     45000 + '/' + 12).subscribe(result => {
  //       this.defaultOfferList = result;
  //     });
  // }

  // on tab click
  onTabClick(value) {
    // this.showTab = value.id;
    this.httpService.getById(emiGlobals.questionUrl + '/' + value.id).subscribe(result => {
      this.subQuestionList = result;
      this.subQuestionList.forEach(element => {
        if (element.option_id === InputType.checkbox) {
          this.httpService.getById(emiGlobals.optionUrl + '/' + element.id).subscribe(result => {
            this.checkList = result;
          });
        }
      });
    });
  }

  // on click of bank
  OnClickOfBank(bank) {
    this.activeButton = bank.value;
    this.productOffer.salaryAccountBank = bank.value;
    localStorage.setItem('salaryBank', bank.value);
    this.next(this.active_group_id);
  }

  //  dynamic form
  getFormData() {
    if (this.dataObject !== null && this.dataObject !== undefined) {
      // remap the API to be suitable for iterating over it
      this.objectProps =
        Object.keys(this.dataObject)
          .map(prop => {
            return Object.assign({}, { key: prop }, this.dataObject[prop]);
          });
      // setup the form
      const formGroup = {};
      for (let prop of Object.keys(this.dataObject)) {
        formGroup[this.dataObject[prop].category_id] =
          new FormControl(this.dataObject[prop].default_value || '', this.mapValidators(this.dataObject[prop].validation));
      }
      this.form = new FormGroup(formGroup);
    }
  }

  // toggle question and form
  onclickOfButton(id) {
    this.productOffer.questionType = id;
    this.showTextField = true;
  }
  // on click of bank
  OnClickOfSalaryBank(bank) {
  //  this.companySelect.nativeElement.remove();
    this.activeButton = bank;
    this.productOffer.salaryAccountBank = bank;
    localStorage.setItem('salaryBank', bank);
 // this.getCompanyList();
  }

  ngOnDestroy() {
    this.calculatorService.clearCurrentData();
    this.calculatorService.inputValues = [];
    this.calculatorService.offer = []
  }

}



// WEBPACK FOOTER //
// ./src/app/calculators/home-loan-comparison-calculator/questions/questions.component.ts